module.exports = __webpack_public_path__ + "media/signup-react/facebook-72cc5ec2.svg";